import React from "react"
import { Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../../localization/strings"
import { IUserDocument } from "../../../models"
import autobind from "class-autobind"
interface IProps {
  users: IUserDocument[]
  close(): void
  confirm(togetherDeleteESS: boolean): void
}
interface IState {
  togetherDeleteESS: boolean
}

export default class DeleteEssAccountUserConfirmDialog extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      togetherDeleteESS: false,
    }
    autobind(this)
  }
  render() {
    return (
      <div>
        <Dialog
          title={this.props.users.length > 1 ? strings.DELETE_SELECTED_USERS : strings.DELETE_SELECTED_USER}
          actions={[
            <FlatButton
              data-intercom-target={"DeleteEssUser-Confirm-Dialog-Btn-CloseDialog"}
              label={strings.CANCEL}
              primary={false}
              onClick={this.props.close}
            />,
            <FlatButton
            data-intercom-target={"DeleteEssUser-Confirm-Dialog-Btn-Confirm"}
              label={strings.OK}
              primary={true}
              keyboardFocused={true}
              onClick={() => this.props.confirm(this.state.togetherDeleteESS)}
            />
          ]}
          modal
          open
          onRequestClose={this.props.close}
        >
          <div>
            {strings.Are_you_sure_you_want_to_delete_the_selected_account_user_with_below_option}
          </div>
          <Toggle
            data-intercom-target={"DeleteEssUser-Confirm-Dialog-Toggle-AlsoRemoveESS"}
            toggled={this.state.togetherDeleteESS}
            onToggle={(e, value) => this.setState({ togetherDeleteESS: value })}
            labelPosition="left"
            label={strings.Also_remove_employee_self_service}
            style={{ maxWidth: 300, marginTop: 10 }}
            labelStyle={{ color: "rgba(97, 97, 97, 0.6)" }}
          />
        </Dialog>
      </div>
    )
  }
}